import { createAction, props } from '@ngrx/store';
import { UserJobStateDto } from 'src/app/services/api.services';
import { AppError } from 'src/app/shared/utils';
import { Job, TrackedJobOptions } from './types';


export const getState = createAction(
  '[InsightsJobs] Get State',
  props<{ id: any }>()
);

export const getStateSuccess = createAction(
  '[InsightsJobs] Get State Success',
  props<{ id: any, job: Job }>()
);

export const getStateFailure = createAction(
  '[InsightsJobs] Get State Failed',
  props<{ id: any, error: AppError }>()
);


export const onStarted = createAction(
  '[InsightsJobs] On Started',
  props<{ id: any, options: TrackedJobOptions }>()
);

export const onCompleted = createAction(
  '[InsightsJobs] On Completed',
  props<{ id: any, getStateFailed?: boolean }>()
);


export const startTracking = createAction(
  '[InsightsJobs] Start Tracking',
  props<{ id: any, options: TrackedJobOptions }>()
);

export const stopTracking = createAction(
  '[InsightsJobs] Stop Tracking',
  props<{ id: any }>()
);
